import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { CallbackComponent, createUserManager } from 'redux-oidc';
import { UserActionCreators } from '../actions';
import { OidcConfiguration } from '../configs/oidc';

class RedirectComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userManager: null
		};
	}
	async componentDidMount() {
		if (this.props.serverIdentity) {
			const userManager = createUserManager({ ...OidcConfiguration, ...this.props.serverIdentity });
			this.setState({ userManager: userManager });
			const user = await userManager.getUser();
			if (user) {
				await userManager.storeUser(user);
			}
		}
	}
	async componentDidUpdate(prevProps) {
		if (prevProps.serverIdentity !== this.props.serverIdentity && this.props.serverIdentity) {
			const userManager = createUserManager({ ...OidcConfiguration, ...this.props.serverIdentity });
			this.setState({ userManager: userManager });
			const user = await userManager.getUser();
			if (user) {
				await userManager.storeUser(user);
			}
		}
	}
	errorCallback = (error) => console.error(error);
	render() {
		const { userManager } = this.state;

		return (
			<Fragment>
				{!userManager && (
					<div className="loader-container">
						<div className="loader-container-inner">
							<h6 className="mt-3">
								Proszę poczekać, za chwilę nastąpi przekierowanie do strony aplikacji...
							</h6>
						</div>
					</div>
				)}
				{userManager && (
					<CallbackComponent
						successCallback={(user) => {
							try {
								this.props.storeUser(user);
							} catch (err) {
								console.error('storeUser', err);
							}

							try {
								this.props.goTo('/');
							} catch (err) {
								console.error('goto', err);
							}
						}}
						errorCallback={this.props.errorCallback}
						userManager={userManager}
					>
						<div className="loader-container">
							<div className="loader-container-inner">
								<h6 className="mt-3">
									Proszę poczekać, za chwilę nastąpi przekierowanie do strony aplikacji...
								</h6>
							</div>
						</div>
					</CallbackComponent>
				)}
			</Fragment>
		);
	}
}
const mapStateToProps = (state, ownProps) => {
	return {
		serverIdentity: state.app.serverIdentity
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators(UserActionCreators, dispatch),
		...{
			goTo: (url) => dispatch(push(url))
		}
	};
};
export const RedirectComponentCallback = connect(mapStateToProps, mapDispatchToProps)(RedirectComponent);
